/**
 * index.ts - Integration preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export { integratrModule } from './integratr';

import { integratrModule } from './integratr';

export const integrationModules = [
  integratrModule
];

export default integrationModules;
